import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import styles from './Record.module.less';
// import { PCStoreJsBridge } from '../../nativeapi';
import { getFeedbackRecords, setFeedbackRecords } from '../../actions/userFeedback';
import Btn from '../../components/Btn/Btn';
import useLoginStatus from '../../utils/hooks/useLoginStatus';

const selectRecords = createSelector(
  state => state.userFeedback,
  userFeedback => userFeedback.records,
);
export default () => {
  const loginStatus = useLoginStatus();
  const records = useSelector(selectRecords);
  const dispatch = useDispatch();

  useEffect(() => {
    if (loginStatus) {
      dispatch(getFeedbackRecords());
    }
  }, [loginStatus]);

  const handleLogin = () => {
    window.CallNativeMethod('login'); // 未登录 调用登录弹窗
  };

  const handleRecords = index => () => {
    const temp = [...records];
    if (temp && temp.length > 0 && temp[index]) {
      temp[index].open = !temp[index].open;
    }
    dispatch(setFeedbackRecords(temp));
  };

  return (
    <div className={styles.record}>
      {loginStatus && records && records.length > 0 && (
        <ul className={styles.record_list}>
          {records.map((item, index) => {
            return (
              <li className={classNames(styles.record_item)} key={index}>
                <div className={styles.record_item_time}>{item.feedbackTime}</div>
                <div
                  className={classNames(styles.record_item_title, {
                    [styles.record_item_spaceo]: item.replyList && item.replyList.length > 0,
                  })}
                  style={item.showIcon ? { cursor: 'pointer' } : {}}
                  onClick={handleRecords(index)}
                >
                  <div
                    className={styles.record_item_detail}
                    style={
                      item.open
                        ? {}
                        : {
                            maxHeight: '21px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }
                    }
                  >
                    {item.feedbackInfo}
                  </div>
                  {item.showIcon && (
                    <i
                      className={classNames(
                        'iconfont',
                        item.open ? 'icon-arrow_up_small' : 'icon-arrow_down_small',
                        styles.record_item_title_icon,
                      )}
                    />
                  )}
                </div>
                <div className={styles.record_item_res}>
                  {item.replyList &&
                    item.replyList.map((res, key) => (
                      <div key={`${index}_${key}`}>
                        <div dangerouslySetInnerHTML={{ __html: `客服：${res.replyMessage}` }} />
                        <div className={styles.record_item_res_time}>{res.replyTime}</div>
                      </div>
                    ))}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      {loginStatus && (!records || records.length === 0) && (
        <div className={styles.no_records}>您暂无反馈记录</div>
      )}
      {!loginStatus && (
        <div className={styles.login}>
          <Btn primary className={styles.login_btn} handleClick={handleLogin}>
            登录
          </Btn>
          <div className={styles.login_btn_desc}>查看历史反馈记录</div>
        </div>
      )}
    </div>
  );
};
